/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    CLIENT_ADMIN_LOGIN_STATS_SERVICE
 * Date:         2026-01-07
 * Modified By:  Cursor
 *
 * Description:
 * Client service to fetch aggregated login stats for admin UI.
 */

import axios from 'axios';
import { getAuthHeaders } from '../../utils/authUtils';
import { config } from '../../config/environment';

const API_URL = config.apiUrl;

export interface RecentUser {
  _id?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  lastLogin?: string | Date;
  loginCount?: number;
}

export interface RecentFailed {
  userId?: string;
  email?: string | null;
  createdAt: string | Date;
}

export interface LoginStatsResponse {
  activeUsersCount: number;
  recentUsers: RecentUser[];
  totalLoginCount: number;
  failedAttemptsCountWindow: number;
  failedAttemptsCount24h: number;
  recentFailedAttempts: RecentFailed[];
}

export async function getLoginStats(days = 7): Promise<LoginStatsResponse> {
  const res = await axios.get(`${API_URL}/api/admin/login-stats`, {
    headers: getAuthHeaders().headers,
    params: { days }
  });
  return res.data.data;
}

